import React from 'react';
import { sponsorData } from '../../Utils/dummyData';

const SponsorshipHistory = () => {
  const { sponsorshipHistory, summary } = sponsorData;

  return (
    <div className="p-6">
      <h1 className="text-2xl font-semibold text-primary-900">Sponsorship History</h1>
      <p className="text-tertiary-600 mt-2">View all past sponsorships and renewal options.</p>

      <div className="mt-6 grid grid-cols-1 md:grid-cols-3 gap-4">
        <div className="rounded-lg border border-slate-200 bg-slate-50 p-4">
          <p className="text-xs uppercase text-slate-500">Tier</p>
          <p className="text-xl font-semibold text-primary-900">{summary.tier}</p>
        </div>
        <div className="rounded-lg border border-slate-200 bg-slate-50 p-4">
          <p className="text-xs uppercase text-slate-500">Total Amount</p>
          <p className="text-xl font-semibold text-primary-900">
            ${summary.totalAmount.toLocaleString()}
          </p>
        </div>
        <div className="rounded-lg border border-slate-200 bg-slate-50 p-4">
          <p className="text-xs uppercase text-slate-500">Events Sponsored</p>
          <p className="text-xl font-semibold text-primary-900">{summary.eventsSponsored}</p>
        </div>
      </div>

      <div className="mt-6 rounded-lg border border-slate-200 overflow-hidden">
        <div className="bg-slate-50 px-4 py-3 font-semibold text-slate-800">
          Past Sponsorships
        </div>
        <div className="divide-y divide-slate-200">
          {sponsorshipHistory.map((item, index) => (
            <div
              key={index}
              className="grid grid-cols-2 md:grid-cols-5 gap-3 px-4 py-3 text-sm text-slate-700"
            >
              <span>{item.date}</span>
              <span>{item.event}</span>
              <span>${item.amount.toLocaleString()}</span>
              <span className="font-medium">{item.tier}</span>
              <span className="capitalize">{item.status}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default SponsorshipHistory;

